import React, { useEffect } from 'react';
import axios from 'axios';
import { useMediaQuery } from 'react-responsive';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  LinearProgress,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core';
import { CSVLink } from 'react-csv';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import SortIcon from '@material-ui/icons/Sort';
import PhoneIcon from '@material-ui/icons/Phone';
import {
  StyledTableCell,
  StyledTableHeadCell,
  StyledTableHeadCell1,
  StyledTableHeadCell2,
  StyledTablePagination,
} from '../../customUI/table/TableStyles';
import GreenButton from '../../customUI/GreenButton';
import BlueButton from '../../customUI/BlueButton';
import { formatPhoneNumber } from '../../functions';
import DefaultInput from '../../customUI/DefaultInput';
import MobileTitle from '../../customUI/MobileTitle';
import MobileCallsCard from './MobileCallsCard';
import { leadsActions } from '../../store/leads-reducer';
import useStyles from './LeadsFullView.style';
import { storeContext } from '../provider/Provider';

const { REACT_APP_FLASK_API_URL } = process.env;

const CallsFullView = () => {
  let isPhone = false;
  const { state, dispatch } = React.useContext(storeContext);
  if (!state.websiteAnalytics.isTesting) {
    isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  }
  const classes = useStyles();
  const [tableBodyHeight, setTableBodyHeight] = React.useState(300);
  const [isInternalFetching, setIsInternalFetching] = React.useState(false);
  const [order, setOrder] = React.useState('desc');
  const [openDialog, setOpenDialog] = React.useState(false);
  const [fullName, setFullName] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [currentCallId, setCurrentCallId] = React.useState('');
  const [currentCallNumber, setCurrentCallNumber] = React.useState('');

  const updateRows = (page, perPage, sort) => {
    setIsInternalFetching(true);
    if (document.getElementById('tableBody')) {
      setTableBodyHeight(
        document.getElementById('tableBody').clientHeight > 300
          ? document.getElementById('tableBody').clientHeight
          : 300
      );
    }
    axios
      .get(
        `${REACT_APP_FLASK_API_URL}/v1/get-call-metrics/${state.websiteSwitch.currentWebsite}/${page}/${perPage}/${sort}`
      )
      .then((res) => {
        dispatch({
          type: leadsActions.LEADS_SET_ALL,
          payload: {
            isFetching: false,
            totalCalls: res.data.total_count,
            calls: res.data.message,
          },
        });
        setIsInternalFetching(false);
      });
      axios
      .get(
        `${REACT_APP_FLASK_API_URL}/v1/get-call-metrics/${state.websiteSwitch.currentWebsite}/${page}/${perPage}/${sort}?status=-no answer,-failed`
      )
      .then((res) => {
        dispatch({
          type: leadsActions.LEADS_SET_ALL,
          payload: {
            isFetching: false,
            totalAnsweredCalls: res.data.total_count,
            answeredCalls: res.data.message,
          },
        });
        setIsInternalFetching(false);
      });
  };

  useEffect(() => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        isFetching: true,
      },
    });
    updateRows(1, state.leads.perPage, order);
  }, [1, state.leads.perPage, order]);

  useEffect(() => {
    axios
      .get(`${REACT_APP_FLASK_API_URL}/v1/get-call-metrics/${state.websiteSwitch.currentWebsite}`)
      .then((res) => {
        dispatch({
          type: leadsActions.LEADS_SET_ALL,
          payload: {
            callsToExport: res.data.message,
          },
        });
      });
  }, []);

  const handleChangePage = (event, newPage) => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        currentPage: newPage,
      },
    });
    updateRows(newPage + 1, state.leads.perPage, order);
  };

  const handleSetOrder = () => {
    if (order === 'desc') {
      setOrder('asc');
    } else {
      setOrder('desc');
    }
    updateRows(1, state.leads.perPage, order);
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        perPage: parseInt(event.target.value, 10),
        currentPage: 0,
      },
    });
    updateRows(1, parseInt(event.target.value, 10));
  };

  if (state.leads.isFetching) {
    return (
      <LinearProgress
        style={{ width: '100%' }}
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    );
  }
  const handleConvertCall = () => {
    const leadBody = {
      email,
      fullName,
      message,
      phone: currentCallNumber,
      website: state.websiteSwitch.currentWebsite,
    };
    axios
      .post(
        `${REACT_APP_FLASK_API_URL}/v1/calls/convert-to-lead/${state.websiteSwitch.currentWebsite}/${currentCallId}`,
        leadBody
      )
      .then((res) => {
        if (res.data.success) {
          setOpenDialog(false);
          updateRows(state.leads.currentPage, state.leads.perPage);
          setEmail('');
          setFullName('');
          setMessage('');
          setCurrentCallNumber('');
          setCurrentCallId('');
        }
      });
  };

  const addZero = (i) => {
    if (i < 10) {
      return `0${i.toString()}`;
    }
    return i;
  };

  if (isPhone) {
    return (
      <>
        <MobileTitle title="Calls" />
        {state.leads.answeredCalls && !isInternalFetching ? (
          <div>
            {state.leads.answeredCalls.map((row) => (
              <MobileCallsCard row={row} />
            ))}
          </div>
        ) : (
          <>{!isInternalFetching && <div style={{ margin: '5% 0 0 5%' }}>No results</div>}</>
        )}
        {isInternalFetching && (
          <div className={classes.loading} style={{ height: 400 }}>
            <CircularProgress />
          </div>
        )}
        {!state.leads.isSearching && (
          <StyledTablePagination
            rowsPerPageOptions={[15, 50]}
            component="div"
            count={state.leads.totalAnsweredCalls}
            rowsPerPage={state.leads.perPage}
            page={state.leads.currentPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Rows:"
          />
        )}
      </>
    );
  }
  return (
    <div className={classes.wrapper}>
      <div className={classes.card}>
        <div className={classes.card__wrapper}>
          <div className={classes.card__header_alone}>
            <div className={classes.heading}>All Calls</div>
            {state.leads.callsToExport.length ? (
              <>
                <CSVLink
                  data={state.leads.callsToExport}
                  filename={`ctm_${state.websiteSwitch.currentWebsite}.csv`}
                  style={{
                    color: '#00B5E2',
                    fontSize: '1.3rem',
                  }}
                >
                  Export to csv
                </CSVLink>
              </>
            ) : (
              <></>
            )}
          </div>
          {state.leads.totalAnsweredCalls ? (
            <>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableHeadCell1>
                      Date{' '}
                      <SortIcon
                        className={`${classes.sortIcon} ${order === 'asc' ? 'asc' : ''}`}
                        onClick={handleSetOrder}
                      />
                    </StyledTableHeadCell1>
                    <StyledTableHeadCell>Time</StyledTableHeadCell>
                    <StyledTableHeadCell align="left">Phone</StyledTableHeadCell>
                    <StyledTableHeadCell align="left">Source</StyledTableHeadCell>
                    <StyledTableHeadCell align="center">Status</StyledTableHeadCell>
                    <StyledTableHeadCell align="center">Duration</StyledTableHeadCell>
                    <StyledTableHeadCell align="center">Review Call</StyledTableHeadCell>
                    <StyledTableHeadCell2 align="center">Action</StyledTableHeadCell2>
                  </TableRow>
                </TableHead>
                {!isInternalFetching && (
                  <TableBody id="tableBody">
                    {state.leads.answeredCalls.map((row) => (
                      <TableRow key={row.id}>
                        <StyledTableCell component="th" scope="row">
                          {`${new Date(row.called_at).toLocaleString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                          })}`}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {encodeURIComponent(addZero(new Date(row.called_at).getHours()))}
                          <span>:</span>
                          {encodeURIComponent(addZero(new Date(row.called_at).getMinutes()))}
                          <span>:</span>
                          {addZero(new Date(row.called_at).getSeconds())}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row" align="left">
                          <a
                            className={classes.blackLink}
                            href={`tel:${row.caller_number_complete.replace(/[^\\d]/g, '')}`}
                          >
                            <PhoneIcon style={{ fontSize: 'small', marginRight: 5 }} />
                            {formatPhoneNumber(row.caller_number_complete)}
                          </a>
                        </StyledTableCell>
                        <StyledTableCell align="left">{row.source}</StyledTableCell>
                        <StyledTableCell align="center">{row.status}</StyledTableCell>
                        <StyledTableCell align="center">
                          {new Date(row.duration * 1000).toISOString().substr(11, 8)}
                        </StyledTableCell>
                        <StyledTableCell align="right" style={{ textAlign: 'center' }}>
                          {row.audio ? (
                            <PlayCircleOutlineIcon
                              style={{ cursor: 'pointer', color: '#38C0F0' }}
                              onClick={() => window.open(row.audio, '_blank')}
                            />
                          ) : (
                            <p style={{ cursor: 'not-allowed', color: '#999999' }}>N/A</p>
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <BlueButton
                            aria-label="convert call to lead"
                            onClick={() => {
                              setCurrentCallNumber(row.caller_number_complete);
                              setCurrentCallId(row.id);
                              setOpenDialog(true);
                            }}
                          >
                            Add Lead
                          </BlueButton>
                        </StyledTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </>
          ) : (
            <>
              {!isInternalFetching && (
                <div className={classes.noContentBlock}>
                  <span>No Results</span>
                </div>
              )}
            </>
          )}
        </div>
        {isInternalFetching && (
          <div className={classes.loading} style={{ height: tableBodyHeight }}>
            <CircularProgress />
          </div>
        )}
        <Divider />
        <div className={classes.card__wrapper}>
          <div className={classes.cardActionButton} aria-hidden="true">
            <StyledTablePagination
              rowsPerPageOptions={[15, 50]}
              component="div"
              count={state.leads.totalAnsweredCalls}
              rowsPerPage={state.leads.perPage}
              page={state.leads.currentPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>
      </div>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          setFullName('');
          setMessage('');
          setCurrentCallNumber('');
        }}
      >
        <DialogTitle>Convert {currentCallNumber} Call to Lead</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="full name"
            label="Contact's Full Name *"
            fullWidth
            value={fullName}
            onChange={(e) => {
              setFullName(e.target.value);
            }}
          />
          <TextField
            margin="dense"
            id="full name"
            label="Contact's Email *"
            fullWidth
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <DefaultInput
            style={{ marginTop: 10, width: '100%' }}
            rows={5}
            multiline
            label="Message"
            value={message}
            data-testid="details_test_id"
            type="text"
            onChange={(e) => {
              setMessage(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialog(false);
              setFullName('');
              setMessage('');
              setCurrentCallNumber('');
            }}
            style={{ color: '#58595B' }}
          >
            Cancel
          </Button>
          <GreenButton aria-label="submit convert" onClick={handleConvertCall}>
            Submit
          </GreenButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CallsFullView;
